/**
 * WPS Unverified Theme - Main JavaScript
 *
 * @package WPS_Unverified_Theme
 */

import { HeroAnimations } from "./animations/HeroAnimations";
import { AppearenceAnimations } from "./animations/AppearenceAnimations";
import { ScrollAnimations } from "./animations/ScrollAnimations";
import { SwiperAnimations } from "./animations/SwiperAnimation";
import { initContactForms } from "./components/ContactForm";

/**
 * Initialize theme
 */
class WPSUnverifiedTheme {
  constructor() {
    this.init();
  }

  /**
   * Initialize all components
   */
  init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.onReady());
    } else {
      this.onReady();
    }
  }

  /**
   * On DOM ready
   */
  onReady() {
    this.waitForFonts().then(() => {
      this.initLenis();
      // this.initSplitText();
      this.initAOS();
      // this.initLoader();
      this.initAnimations();
      initContactForms();
    });
  }

  waitForFonts() {
    if (!document.fonts || !document.fonts.ready) {
      return Promise.resolve();
    }

    return document.fonts.ready;
  }

  /**
   * Initialise Lenis
   */
  initLenis() {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      smoothTouch: false,
      lerp: 0.08,
      prevent: (node) => node.closest(".wps-fullscreen-menu"),
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }

  /**
   * Initialise SplitText
   */
  // initSplitText() {
  //   if (typeof gsap === "undefined" || typeof SplitText === "undefined") {
  //     console.warn("GSAP or SplitText not loaded");
  //     return;
  //   }

  //   gsap.registerPlugin(SplitText);

  //   const mainTitles = [...document.querySelectorAll("[data-main-title]")];
  //   if (mainTitles) {
  //     mainTitles.forEach((title) => {
  //       const split = new SplitText(title, {
  //         type: "chars",
  //         charsClass: "text-chars",
  //       });
  //     });
  //   }

  //   const subTitles = [...document.querySelectorAll("[data-sub-title]")];
  //   if (subTitles) {
  //     subTitles.forEach((title) => {
  //       const split = new SplitText(title, {
  //         type: "words,chars",
  //         wordsClass: "text-words",
  //         charsClass: "text-chars",
  //       });
  //     });
  //   }
  // }

  /**
   * Initialize AOS (Animate On Scroll)
   */
  initAOS() {
    if (typeof AOS !== "undefined") {
      AOS.init({
        duration: 800,
        easing: "ease-in-out-sine",
        once: true,
        offset: 100,
        delay: 0,
      });
    }
  }

  /**
   * Loader Animation
   */

  // initLoader() {
  //   const section = document.querySelector(".wps-header-preloader__wrapper");
  //   const heroSection = document.querySelector(".wps-header-hero__wrapper");

  //   if (heroSection) {
  //     const chars = [...heroSection.querySelectorAll(".text-chars")];

  //     chars.forEach((char) => {
  //       char.textContent = Math.floor(Math.random() * 10);
  //     });
  //   }

  //   const tc = document.querySelector(".timecode");

  //   let frame = 0;

  //   const tl = gsap.timeline({
  //     onComplete: finish,
  //   });

  //   tl.to(
  //     {},
  //     {
  //       duration: 2,
  //       onUpdate: () => {
  //         frame++;

  //         let f = frame % 24;
  //         let s = Math.floor(frame / 24) % 60;
  //         let m = Math.floor(frame / 1440) % 60;

  //         tc.textContent = `00:${pad(m)}:${pad(s)}:${pad(f)}`;
  //       },
  //     },
  //   );

  //   function pad(n) {
  //     return n.toString().padStart(2, "0");
  //   }

  //   function finish() {
  //     gsap.to(section, {
  //       autoAlpha: 0,
  //       duration: 0.2,
  //       onComplete: () => {
  //         section.remove();

  //         if (typeof HeroAnimations === "function") {
  //           new HeroAnimations();
  //         }

  //         if (typeof ScrollTrigger !== "undefined") {
  //           ScrollTrigger.refresh(true);
  //         }
  //       },
  //     });
  //   }
  // }

  /**
   * Initialize GSAP and Swiper animations
   */
  initAnimations() {
    if (typeof gsap !== "undefined") {
      new HeroAnimations();
      new ScrollAnimations();
      new AppearenceAnimations();
    }

    if (typeof Swiper !== "undefined" && typeof gsap !== "undefined") {
      new SwiperAnimations();
    }
  }
}

// Initialize theme
new WPSUnverifiedTheme();
